import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { ChevronDown, ChevronUp } from "lucide-react";

interface Logo {
  id: string;
  name: string;
  logo_url: string;
  display_order: number;
}

interface LogoGridProps {
  logos: Logo[];
  viewMoreLabel: string;
  showLessLabel: string;
}

const LogoGrid = ({ logos, viewMoreLabel, showLessLabel }: LogoGridProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const initialLogosCount = 20;
  const initialLogos = logos.slice(0, initialLogosCount);
  const displayedLogos = isExpanded ? logos : initialLogos;
  const hasMoreLogos = logos.length > initialLogos.length;

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 max-w-6xl mx-auto">
        {displayedLogos.map((logo, index) => (
          <div
            key={`${logo.id}-${index}`}
            className="group flex items-center justify-center"
          >
            <div className="w-full aspect-[3/2] p-3 flex items-center justify-center"
                 style={{ maxWidth: '180px' }}>
              <img
                src={logo.logo_url}
                alt={logo.name}
                className="max-w-full max-h-full w-auto h-auto object-contain transition-transform duration-300 group-hover:scale-110"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        ))}
      </div>
      
      {hasMoreLogos && (
        <div className="flex justify-center">
          <Button
            variant="outline"
            onClick={() => setIsExpanded(!isExpanded)}
            className="mt-4 rounded-full border-primary/20 text-primary hover:bg-primary/5 hover:text-primary"
          >
            {isExpanded ? (
              <>
                {showLessLabel} <ChevronUp className="ml-2 h-4 w-4" />
              </>
            ) : (
              <>
                {viewMoreLabel} <ChevronDown className="ml-2 h-4 w-4" />
              </>
            )}
          </Button>
        </div>
      )}
    </div>
  );
};

export default LogoGrid;